import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-quick-options-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="quick-options-content p-4">
      <h3 class="text-lg font-medium text-theme-text-primary mb-5 font-['Lexend',_sans-serif]">Quick Actions</h3>
      
      <div class="grid gap-4 auto-cols-fr grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        <button 
          class="flex items-center gap-3 p-4 border border-light rounded-lg bg-theme-bg-card hover:bg-theme-bg-secondary hover:border-theme-brand-primary transition-all duration-200 cursor-pointer font-['Lexend',_sans-serif] text-sm font-normal text-theme-text-primary text-left hover:transform hover:-translate-y-0.5 hover:shadow-lg hover:shadow-theme-brand-primary/10"
          (click)="onQuickAction('export')">
          <svg 
            class="w-6 h-6 text-theme-brand-primary flex-shrink-0" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7,10 12,15 17,10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          <span class="text-theme-text-primary font-medium">Export Data</span>
        </button>
        
        <button 
          class="flex items-center gap-3 p-4 border border-light rounded-lg bg-theme-bg-card hover:bg-theme-bg-secondary hover:border-theme-brand-primary transition-all duration-200 cursor-pointer font-['Lexend',_sans-serif] text-sm font-normal text-theme-text-primary text-left hover:transform hover:-translate-y-0.5 hover:shadow-lg hover:shadow-theme-brand-primary/10"
          (click)="onQuickAction('print')">
          <svg 
            class="w-6 h-6 text-theme-brand-primary flex-shrink-0" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2">
            <polyline points="6,9 6,2 18,2 18,9"/>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
            <rect x="6" y="14" width="12" height="8"/>
          </svg>
          <span class="text-theme-text-primary font-medium">Print Profile</span>
        </button>
        
        <button 
          class="flex items-center gap-3 p-4 border border-light rounded-lg bg-theme-bg-card hover:bg-theme-bg-secondary hover:border-theme-brand-primary transition-all duration-200 cursor-pointer font-['Lexend',_sans-serif] text-sm font-normal text-theme-text-primary text-left hover:transform hover:-translate-y-0.5 hover:shadow-lg hover:shadow-theme-brand-primary/10"
          (click)="onQuickAction('share')">
          <svg 
            class="w-6 h-6 text-theme-brand-primary flex-shrink-0" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2">
            <circle cx="18" cy="5" r="3"/>
            <circle cx="6" cy="12" r="3"/>
            <circle cx="18" cy="19" r="3"/>
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
          </svg>
          <span class="text-theme-text-primary font-medium">Share Profile</span>
        </button>
        
        <button 
          class="flex items-center gap-3 p-4 border border-light rounded-lg bg-theme-bg-card hover:bg-theme-bg-secondary hover:border-theme-brand-primary transition-all duration-200 cursor-pointer font-['Lexend',_sans-serif] text-sm font-normal text-theme-text-primary text-left hover:transform hover:-translate-y-0.5 hover:shadow-lg hover:shadow-theme-brand-primary/10"
          (click)="onQuickAction('bookmark')">
          <svg 
            class="w-6 h-6 text-theme-brand-primary flex-shrink-0" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
          </svg>
          <span class="text-theme-text-primary font-medium">Bookmark</span>
        </button>
        
        <button 
          class="flex items-center gap-3 p-4 border border-light rounded-lg bg-theme-bg-card hover:bg-theme-bg-secondary hover:border-theme-brand-primary transition-all duration-200 cursor-pointer font-['Lexend',_sans-serif] text-sm font-normal text-theme-text-primary text-left hover:transform hover:-translate-y-0.5 hover:shadow-lg hover:shadow-theme-brand-primary/10"
          (click)="onQuickAction('edit')">
          <svg 
            class="w-6 h-6 text-theme-brand-primary flex-shrink-0" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
          </svg>
          <span class="text-theme-text-primary font-medium">Quick Edit</span>
        </button>
        
        <button 
          class="flex items-center gap-3 p-4 border border-light rounded-lg bg-theme-bg-card hover:bg-theme-bg-secondary hover:border-theme-brand-primary transition-all duration-200 cursor-pointer font-['Lexend',_sans-serif] text-sm font-normal text-theme-text-primary text-left hover:transform hover:-translate-y-0.5 hover:shadow-lg hover:shadow-theme-brand-primary/10"
          (click)="onQuickAction('history')">
          <svg 
            class="w-6 h-6 text-theme-brand-primary flex-shrink-0" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12,6 12,12 16,14"/>
          </svg>
          <span class="text-theme-text-primary font-medium">View History</span>
        </button>
      </div>
    </div>
  `,
  styles: [`
    /* Mobile responsive adjustments */
    @media (max-width: 768px) {
      .quick-options-content {
        padding: 12px 16px;
      }
      
      .quick-options-content h3 {
        font-size: 16px;
        margin-bottom: 16px;
      }
      
      .quick-options-content .grid {
        grid-template-columns: 1fr;
        gap: 12px;
      }
      
      .quick-options-content button {
        padding: 12px;
        font-size: 13px;
      }
    }
  `]
})
export class QuickOptionsModalComponent {
  @Output() actionSelected = new EventEmitter<string>();

  onQuickAction(action: string): void {
    console.log(`Quick action selected: ${action}`);
    this.actionSelected.emit(action);
  }
}
